<template>
  <div class="view pa24">
    <div class="d-flex mb20">
      <div class="bgf7fa pt20 pr20 pl20 pb20 d-flex flex-column mr20 w600">
        <p>{{ $t('turnToIntroduce', 'memberName') }}：{{memberInfo.name}}</p>
        <p>{{ $t('turnToIntroduce', 'partnerName') }}：{{memberInfo.employeeName}}</p>
        <p>{{ $t('turnToIntroduce', 'totalReferralCustomers') }}：{{memberInfo.customerNum}}</p>
        <p>{{ $t('turnToIntroduce', 'successfulCustomers') }}：{{memberInfo.customerNum}}</p>
        <p>{{ $t('turnToIntroduce', 'totalTransactionAmount') }}：{{memberInfo.shopSell + memberInfo.manualSell}}</p>
        <p>{{ $t('turnToIntroduce', 'promotionRewardExpense') }}：{{memberInfo.partnerRate + memberInfo.partnerRateWait}}</p>
      </div>
    </div>
    <div class="d-flex align-items-center">
      
      {{ $t('turnToIntroduce', 'customerName') }}：<el-input class="mr20 w200"  v-model="keyword" :placeholder="$t('turnToIntroduce', 'pleaseEnterCustomerName')"></el-input>
      {{ $t('turnToIntroduce', 'phoneNumber') }}：<el-input class="mr20 w200"  v-model="phone" :placeholder="$t('turnToIntroduce', 'pleaseEnterPhoneNumber')"></el-input>
      <el-select
        v-model="categoriesValue"
        class="w120 mr10"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.title"
          :value="item.type"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        :start-placeholder="$t('turnToIntroduce', 'startDate')"
        :end-placeholder="$t('turnToIntroduce', 'endDate')"
      />
      <el-button type="primary" @click="queryVisitorsData">{{ $t('turnToIntroduce', 'search') }}</el-button>
      <!-- <el-button type="primary" @click="queryVisitorsData">{{ $t('turnToIntroduce', 'export') }}</el-button> -->
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="customerName" align="center" :label="$t('turnToIntroduce', 'customerName')" />
        <el-table-column prop="customerPhone" align="center" :label="$t('turnToIntroduce', 'phoneNumber')" />
        <el-table-column prop="customerWechat" align="center" :label="$t('turnToIntroduce', 'wechatAccount')" />
        <el-table-column prop="createdTime" align="center" :label="$t('turnToIntroduce', 'introductionTime')" />
        <el-table-column prop="type" align="center" :label="$t('turnToIntroduce', 'source')" >
          <template slot-scope="scope">
            <p >{{scope.row.type == 1 ? $t('turnToIntroduce', 'directLead') : $t('turnToIntroduce', 'sharedBusinessCard') }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" :label="$t('turnToIntroduce', 'status')" >
          <template slot-scope="scope">
            <p >{{scope.row.state == 1 ? $t('turnToIntroduce', 'unfollowed') : scope.row.state == 2 ? $t('turnToIntroduce', 'following') : $t('turnToIntroduce', 'successful') }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="manualSell" align="center" :label="$t('turnToIntroduce', 'manualTransactionAmount')" />
        <el-table-column prop="shopSell" align="center" :label="$t('turnToIntroduce', 'mallTransactionAmount')" />
        <el-table-column prop="partnerRate" align="center" :label="$t('turnToIntroduce', 'promotionRewardExpense')" />
        <el-table-column prop="visitTime" align="center" :label="$t('turnToIntroduce', 'operation')">
          <template slot-scope="scope">
            <p class="cblue hover_pointer" @click="toDetailPage(scope.row)">{{ $t('turnToIntroduce', 'details') }}</p>
          </template>
        </el-table-column>
        
      </template>
    </commonTable>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {  
  bossSubordinationBalance
 } from "@/api/financing";
 
 import {  
  customerList,
  employeeDetails,
  details
} from "@/api/turnToIntroduce";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      phone: "",
      startTime: this.startTime,
      endTime: this.endTime,
      keyword:'',
      categoriesValue:'',
      memberInfo:''
    };
  },
  computed: {
    // 将options移到computed中，确保可以访问this.$t
    options() {
      return [
        {
          title: this.$t('turnToIntroduce', 'all'),
          type:''
        },
        {
          title: this.$t('turnToIntroduce', 'unfollowed'),
          type:1
        },
        {
          title: this.$t('turnToIntroduce', 'following'),
          type:2
        },
        {
          title: this.$t('turnToIntroduce', 'successful'),
          type:3
        },
      ];
    },
  },
  watch:{
    categoriesValue(val,old){
      console.log(val)
    }
  },
  created() {
    this.queryVisitorsData();
    this.details()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async queryVisitorsData() {
      var patrn = /^(-)?\d+(\.\d+)?$/;
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        customerPhone: this.phone,
        empId:this.$route.query.empId,
        userId:this.$route.query.userId,
        customerName:this.keyword,
        state:this.categoriesValue,
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      
      if(this.keyword){
        if(patrn.exec(this.keyword)){
          data.phone = this.keyword
        }else{
          data.companyName = this.keyword
        }
      }
      try {
        this.loading = true;
        const result = await customerList(data);
        this.loading = false;
        const { total, list } = result?.data;
        this.tableData = list;
        this.tableData.forEach(item=>{
          item.balance = (item.balance/100).toFixed(2)
          item.commission = (item.commission/100).toFixed(2)
          item.totalPay = (item.totalPay/100).toFixed(2)
        })
        this.total = total;
      } catch (error) {
        this.tableData = []
        this.loading = false;
      }
    },
    details(){
      let data = {
        epId:this.$route.query.epId
      }
      details(data)
      .then(res=>{
        console.log(res)
        if(res && res.data){
          this.memberInfo = res.data
        }
      })
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+"秒";
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+"分"+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+"小时"+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
    toDetailPage(item){
      if(!item.customerCardId){
        this.$message.error(this.$t('turnToIntroduce', 'customerNotStored'))
        return
      }
      this.$router.push('../customerDetall?id=' + item.customerCardId)
    }
  },
};
</script>

<style lang="scss" scoped>
</style>